"use client";

import { useEffect, useState } from "react";
import Popup from "./Popup";

export default function VideoPopup({
  isOpen,
  callback,
  videoSourceUrl,
  title,
  isPrismicVideo,
  ignoreCookies = false,
}: {
  isOpen: boolean;
  callback: () => void;
  videoSourceUrl: string;
  title?: string;
  isPrismicVideo: boolean;
  ignoreCookies?: boolean;
}) {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    setAccepted(
      // @ts-expect-error Cookiebot is initialized with a script tag
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/prefer-optional-chain, @typescript-eslint/no-unsafe-member-access
      typeof window !== "undefined" && window?.Cookiebot?.consent?.marketing,
    );
  }, [isOpen]);

  const renewCookies = () => {
    // @ts-expect-error Cookiebot is initialized with a script tag
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    window?.Cookiebot?.renew();
  };

  return (
    <Popup isOpen={isOpen} closeCallback={() => callback()}>
      <div className="relative bg-white px-2 py-10 md:px-10">
        {/* Close button */}
        <button
          onClick={() => callback()}
          aria-label="Close popup"
          className="group absolute right-0 top-0 flex h-10 w-10 items-center justify-center"
        >
          <div className="relative w-4 rotate-0 transition-transform group-hover:rotate-90">
            <span className="absolute left-0 inline-block h-px w-4 -rotate-45 bg-black"></span>
            <span className="absolute left-0 inline-block h-px w-4 rotate-45 bg-black"></span>
          </div>
        </button>
        {/* Video */}
        {isPrismicVideo ? (
          <video
            disablePictureInPicture
            disableRemotePlayback
            playsInline
            controls
            src={videoSourceUrl}
            className="aspect-video w-full"
          ></video>
        ) : (
          <>
            {!ignoreCookies && (
              <div className="cookieconsent-optout-marketing">
                Please accept marketing-cookies to watch this video. Your cookie
                preferences can be changed{" "}
                <span
                  onClick={() => renewCookies()}
                  className="cursor-pointer text-blue underline decoration-blue/0 transition-colors hover:decoration-blue"
                >
                  here
                </span>
              </div>
            )}
            {(accepted || ignoreCookies) && (
              <iframe
                className="aspect-video w-full"
                loading="lazy"
                src={videoSourceUrl}
                data-cookieblock-src={videoSourceUrl}
                data-cookieconsent="marketing"
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            )}
          </>
        )}
      </div>
    </Popup>
  );
}
